const red = {
  10: '#F9D6DC',
  50: '#F298A8',
  100: '#F298A8',
  200: '#E8304F',
}

export default red
